/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trialsControllerCreate } from "./trialsControllerCreate";
import { trialsControllerFindAll } from "./trialsControllerFindAll";
import { trialsControllerFindOne } from "./trialsControllerFindOne";
import { trialsControllerUpdate } from "./trialsControllerUpdate";

export function trialsService() {
  return { trialsControllerFindAll, trialsControllerCreate, trialsControllerFindOne, trialsControllerUpdate }
}